import React from "react";
import getBookingFormattedDate from "../../Config/Booking";

export const BookingLeftDetails = (props: any) => {
  const {
    booking_id,
    cancellation_date,
    booking_status,
    session_date,
    booking_date,
    booking_type,
    is_booking_modified,
    createdAt,
    non_app,
    expert_billing_details:{isCorporate},
  } = props;

  return (
    <div className="col-sm-6 px-4">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Booking Id:</th>
            <td>{booking_id}</td>
          </tr>
          <tr>
            <th scope="row">Cancellation Date:</th>
            <td>{getBookingFormattedDate(cancellation_date)}</td>
          </tr>
          <tr>
            <th scope="row">Booking Status:</th>
            <td>{booking_status}</td>
          </tr>
          <tr>
            <th scope="row">Session Date:</th>
            <td>{getBookingFormattedDate(session_date)}</td>
          </tr>
          <tr>
            <th scope="row">Booking Date:</th>
            <td>{getBookingFormattedDate(booking_date)}</td>
          </tr>
          <tr>
            <th scope="row">Booking Type:</th>
            <td colSpan={3}>{booking_type}</td>
          </tr>
          <tr>
            <th scope="row">Created At</th>
            <td colSpan={3}>{createdAt}</td>
          </tr>
          <tr>
            <th scope="row">Is Booking Modified</th>
            <td colSpan={3}>{is_booking_modified.toString()}</td>
          </tr>
          <tr>
            <th scope="row">Is Provisional Booking</th>
            <td colSpan={3}>{non_app.toString()}</td>
          </tr>
          <tr>
            <th scope="row">Is Corporate</th>
            <td colSpan={3}>{isCorporate}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
